export enum reportsUrls {
    seaFerriesSummary = "reports/sea-ferries-summary",
    transportRegister = "reports/transport-register",
    ferryHandlingTime = "reports/ferry-handling-time",
    vehicleOrCargoHandlingTime = "reports/vehicle-or-cargo-handling-time",
    invoiceAttachment = "reports/invoice-attachment",
    dangerousGoodsRegister = "reports/dangerous-goods-register",
    trailerBase = "reports/trailer-base",
    listOfShipments = "reports/list-of-shipments"
}